import { render, staticRenderFns } from "./SurveyReadQuestion.vue?vue&type=template&id=3eb2e60a"
import script from "./SurveyReadQuestion.ts?vue&type=script&lang=ts&external"
export * from "./SurveyReadQuestion.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports